const state = {
  types: [
    {
      category: 'Мотоцикл і моторолер',
      list: [
        {name: '300 см3 чи менше', id: 'A1'},
        {name: 'більше 300 см3', id: 'A2'}
      ],
    },
    {
      category: 'Легковий автомобіль',
      list: [
        {name: 'до 1600 см3', id: 'B1'},
        {name: '1601-2000 см3', id: 'B2'},
        {name: '2001-3000 см3', id: 'B3'},
        {name: 'більше 3001 см3', id: 'B4'},
        {name: 'електромобіль', id: 'B5'}
      ],
    },
    {
      category: 'Вантажний автомобіль',
      list: [
        {name: 'С0 (з повною масою до 2,4т та вантажопідйомністю до 2т)', id: 'C0'},
        {name: 'С1 (з повною масою більше 2,4т та вантажопідйомністю до 2т (включно))', id: 'C1'},
        {name: 'С2 (з вантажопідйомністю більше 2т)', id: 'C2'}
      ],
    },
    {
      category: 'Автобус',
      list: [
        {name: 'Менше 20 чоловік', id: 'D1'},
        {name: 'Більше 20 чоловік', id: 'D2'}
      ],
    },
    {
      category: 'Причіп, Трейлер',
      list: [
        {name: 'До вантажного авто', id: 'E'},
        {name: 'До легковому авто', id: 'F'}
      ],
    },
  ],
  list: [
    {name: 'Всі типи', id: null},
    {name: '300 см3 чи менше (Мотоцикл і моторолер)', id: 'A1'},
    {name: 'більше 300 см3 (Мотоцикл і моторолер)', id: 'A2'},
    {name: 'до 1600 см3 (Легковий автомобіль)', id: 'B1'},
    {name: '1601-2000 см3 (Легковий автомобіль)', id: 'B2'},
    {name: '2001-3000 см3 (Легковий автомобіль)', id: 'B3'},
    {name: 'Легковий електромобіль', id: 'B5'},
    {name: 'більше 3001 см3 (Легковий автомобіль)', id: 'B4'},
    {name: 'Легковий електромобіль', id: 'B5'},
    {name: 'С0 (з повною масою до 2,4т та вантажопідйомністю до 2т)', id: 'C0'},
    {name: 'С1 (з повною масою більше 2,4т та вантажопідйомністю до 2т (включно))', id: 'C1'},
    {name: 'С2 (з вантажопідйомністю більше 2т)', id: 'C2'},
    {name: 'менше 20 осіб (Автобус)', id: 'D1'},
    {name: 'більше 20 осіб (Автобус)', id: 'D2'},
    {name: 'До вантажного авто (Причіп)', id: 'E'},
    {name: 'До легкового авто (Причіп)', id: 'F'},
  ],
  groups: [
    {'name': 'Легкові автомобілі', 'group': 'CAR', 'external_id': 'A'},
    {'name': 'Автобус', 'group': 'BUS', 'external_id': 'E'},
    {'name': 'Вантажні автомобілі', 'group': 'CARGO', 'external_id': 'C'},
    {'name': 'Причіп, Трейлер', 'group': 'TRAILER', 'external_id': 'F', 'type': 'До вантажного авто'},
    {'name': 'Мотоцикли та моторолери', 'group': 'BIKE', 'external_id': 'B'}
  ]
};

const getters = {
  AUTO_CATEGORY_TYPES: state => state.types,
  AUTO_CATEGORIES_LIST: state => state.list,
  AUTO_TYPES_LIST: state => state.groups
};

export default {
  state,
  getters
};
